import type { ReactNode, RefObject } from 'react'
import type { DeviceViewportType } from '../../../types/responsiveness'

interface BaseModalElementProps {
  children?: ReactNode
  className?: string
}

export interface BaseModalFooterProps extends BaseModalElementProps {}

export interface BaseModalHeaderProps extends BaseModalElementProps {}

export interface BaseModalContentProps extends BaseModalElementProps {}

export enum BaseModalSize {
  small = 's',
  medium = 'm',
}

export interface BaseModalProps {
  'aria-labelledby'?: string
  children?: ReactNode
  className?: string
  closeButtonAriaLabel?: string
  dragHandler?: ReactNode
  id?: string
  isOpen: boolean
  fullscreen?: boolean | DeviceViewportType
  onClose?: () => void
  overlayClose?: boolean
  role?: string
  size?: BaseModalSizeType
  showCloseButton?: boolean
  withScrim?: boolean
}

export type BaseModalHandle = {
  getDialogRef: () => RefObject<HTMLDialogElement>
}

type BaseModalSizeType = `${BaseModalSize}`
